import { makeStyles } from "@mui/styles";
import { DefaultTheme } from "@byte-coach/admin-ui-components";

export const useStyles = makeStyles({
  container: {
    paddingTop: '16px',
    paddingBottom: '16px',
    margin: 'auto',
    maxWidth: 500,
    flexGrow: 1,
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    maxWidth: '45px',
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
      textAlign: 'center',
      paddingLeft: '8px',
      paddingRight: '8px',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  button: {
    color: DefaultTheme.palette.primary.main,
    padding: 2,
  }
});
